// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'dev',
  adminADGroupName:'GPI-Aces-Admins',
  //apiBaseURI :'https://localhost:44320/api',
 // apiBaseURI :'https://localhost:5001/api',
  // apiEndPointURI :'https://localhost:5001/api/',
  apiBaseURI: 'https://acesdevapi.graphicpkg.com/api',
  apiEndPointURI :'https://acesdevapi.graphicpkg.com/api/',
  //hostName: 'https://gpi.my.idaptive.app',
  //appName: 'oauthcustomserverapp',
  pagination: { PageSelected: 0, pagesize: 20, SortColumnName: "Id", SortOrder: "DESC" },
  redirectURL: 'https://acesdev.graphicpkg.com/',
 redirectURLForLogout: 'https://acesdev.graphicpkg.com/logout',
  //redirectURL: 'http://localhost:4200/',
  //redirectURLForLogout: 'http://localhost:4200/logout',
  baseUrl: 'https://usazr3dmzdevsa005aces.blob.core.windows.net/images/',
  gtag: 'G-C8XTVXEG93'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
